import {Box, Button, Group, Notification, Stack, Text} from "@mantine/core";
import {StreamErrorMessage, StreamErrorType} from "../../../../types";
import IconMoodSad from "../../../../assets/mood-sad.svg?react";
import IconArrowLeft from "../../../../assets/arrow-left.svg?react";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../../../app/hooks";
import {selectActiveThread} from "../../threadsSlice";
interface Props {
    value?: StreamErrorMessage;
    onResend: () => void;
    onExit: () => void;
}

export const ErrorReason: React.FC<Props> = ({value, onResend, onExit}) => {
    const activeThread = useAppSelector(selectActiveThread);
    const rateLimitCount = activeThread?.rateLimitCount ?? 0;
    const {t} = useTranslation();

    if (!value) {
        return null;
    }

    return (
        <>
            {value.errorType === StreamErrorType.Unknown &&
                !value.message.includes("content_filter") && (
                    <Notification
                        icon={<IconMoodSad />}
                        color="red"
                        title={t("error.unknown.title")}
                        withCloseButton={false}
                    >
                        <Group>
                            <Text size="sm">{t("error.unknown.body")}</Text>
                            <Button
                                variant="outline"
                                size="xs"
                                color="gray"
                                onClick={onResend}
                            >
                                {t("common.tryAgain")}
                            </Button>
                        </Group>
                    </Notification>
                )}
            {(value.errorType === StreamErrorType.ContentFilter ||
                (value.errorType === StreamErrorType.Unknown &&
                    value.message.includes("content_filter"))) && (
                <Box
                    p="lg"
                    bg="gneis.0"
                    style={{borderRadius: "var(--mantine-radius-md)"}}
                >
                    <Stack gap={4}>
                        <Text fw={700}>{t("error.contentFilter.title")}</Text>
                        <Text size="sm">
                            {t("error.contentFilter.editMessageHint", {
                                defaultValue:
                                    "Spørsmålet ble blokkert av innholdsfilteret. Rediger meldingen din over og prøv med andre ord.",
                            })}
                        </Text>
                    </Stack>
                </Box>
            )}
            {value.errorType === StreamErrorType.ContextLengthExceeded && (
                <Notification
                    icon={<IconMoodSad />}
                    color="red"
                    title={t("error.contextLength.title")}
                    withCloseButton={false}
                >
                    <Stack>
                        <Text size="sm">{t("error.contextLength.body")}</Text>
                        <Button
                            variant="outline"
                            size="xs"
                            color="gray"
                            onClick={onExit}
                            leftSection={<IconArrowLeft height="18px" />}
                        >
                            {t("common.goBack")}
                        </Button>
                    </Stack>
                </Notification>
            )}
            {value.errorType === StreamErrorType.RateLimitExceeded &&
                rateLimitCount > 1 && (
                    <Notification
                        icon={<IconMoodSad />}
                        color="red"
                        title={t("error.rateLimit.title")}
                        withCloseButton={false}
                    >
                        <Stack>
                            <Text size="sm">{t("error.rateLimit.body")}</Text>
                            <Button
                                variant="outline"
                                size="xs"
                                color="gray"
                                onClick={onResend}
                            >
                                {t("common.tryAgain")}
                            </Button>
                        </Stack>
                    </Notification>
                )}
        </>
    );
};
